import React from 'react';
import classNames from 'classnames';
import './styles.css';

const CardWrapper = ({ className, children, ...props }) => {
  return (
    <div
      className={classNames('Listview__CardWrapper__root', {
        [className]: className,
      })}
      {...props}
    >
      {children}
    </div>
  );
};

export default CardWrapper;
